import { AuthForm } from './AuthForm';
import { Route } from '../../../routes/auth';
import { AuthLayout } from './AuthLayout';

export function AuthPage() {
  const { signup } = Route.useSearch();
  return (
    <AuthLayout>
      <AuthForm signup={signup ?? false} />
    </AuthLayout>
  );
}
